import React, { useEffect, useState } from 'react';
import { TiPencil } from "react-icons/ti";
import CustomModal from "../Dashboard_Tabs/CustomModal";
import firebase from "../../firebaseConfig";
import "../../styles/generalTabs.css"
import { useAdminView } from '../../contexts/AdminViewContext';

const Cycles_Content = ({ user }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [displayContent, setDisplayContent] = useState("");
    const [fieldName, setFieldName] = useState("");
    const [goalsData, setGoalsData] = useState({});
    const [currentWorkload, setCurrentWorkload] = useState(0);
    const { isAdminView } = useAdminView();

    useEffect(() => {
        const fetchInputValue = async () => {
            try {
                if (user) {
                    const userId = user.uid;
                    const docRef = firebase.firestore().collection('users').doc(userId);
                    const docSnapshot = await docRef.get();
                    if (docSnapshot.exists) {
                        const data = docSnapshot.data().Goals_cycle;
                        if (data){
                            setGoalsData(data);
                        }else{
                            setGoalsData({
                                // Existing fields
                                globalView_cycles_1:'',
                                globalView_cycles_2:'',
                                globalView_cycles_3:'',
                                globalView_cycles_4:'',
                                secondary_cycles_1:'',
                                secondary_cycles_2:'',
                                secondary_cycles_3:'',
                                secondary_cycles_4:'',
                                recovery_cycles_1:'',
                                recovery_cycles_2:'',
                                recovery_cycles_3:'',
                                recovery_cycles_4:'',
                                weekly_schedule_cycle_1:'',
                                weekly_schedule_cycle_2:'',
                                weekly_schedule_cycle_3:'',
                                weekly_schedule_cycle_4:'',
                                repeat_cycle_1:'',
                                repeat_cycle_2:'',
                                repeat_cycle_3:'',
                                repeat_cycle_4:'',
                                easiest_cycle_1:'',
                                easiest_cycle_2:'',
                                easiest_cycle_3:'',
                                easiest_cycle_4:'',

                                cycleType:'normal',

                                cycleLength_0:'cycleLength_0',
                                cycleLength_1:'cycleLength_1',
                                cycleLength_2:'cycleLength_2',
                                cycleLength_3:'cycleLength_3',
                                startingPeriod_0:'startingPeriod_0',
                                startingPeriod_1:'startingPeriod_1',
                                startingPeriod_2:'startingPeriod_2',
                                startingPeriod_3:'startingPeriod_3',
                                endingPeriod_0:'endingPeriod_0',
                                endingPeriod_1:'endingPeriod_1',
                                endingPeriod_2:'endingPeriod_2',
                                endingPeriod_3:'endingPeriod_3',
                                deloading_0:'deloading_0',
                                deloading_1:'deloading_1',
                                deloading_2:'deloading_2',
                                deloading_3:'deloading_3',
                                periodRecovery_0:'periodRecovery_0',
                                periodRecovery_1:'periodRecovery_1',
                                periodRecovery_2:'periodRecovery_2',
                                periodRecovery_3:'periodRecovery_3',
                                nextCycle_0:'nextCycle_0',
                                nextCycle_1:'nextCycle_1',
                                nextCycle_2:'nextCycle_2',
                                nextCycle_3:'nextCycle_3',

                                // New fields for all workload levels (0-3)
                                priority_0:'', priority_1:'', priority_2:'', priority_3:'',
                                nonNegotiable_0:'', nonNegotiable_1:'', nonNegotiable_2:'', nonNegotiable_3:'',
                                meetingsReduce_0:'', meetingsReduce_1:'', meetingsReduce_2:'', meetingsReduce_3:'',
                                projectsPause_0:'', projectsPause_1:'', projectsPause_2:'', projectsPause_3:'',
                                socialLoad_0:'', socialLoad_1:'', socialLoad_2:'', socialLoad_3:'',
                                contextsNotExpand_0:'', contextsNotExpand_1:'', contextsNotExpand_2:'', contextsNotExpand_3:'',
                                workingDays_0:'', workingDays_1:'', workingDays_2:'', workingDays_3:'',
                                dailyStart_0:'', dailyStart_1:'', dailyStart_2:'', dailyStart_3:'',
                                dailyEnd_0:'', dailyEnd_1:'', dailyEnd_2:'', dailyEnd_3:'',
                                targetHours_0:'', targetHours_1:'', targetHours_2:'', targetHours_3:'',
                                meetingCap_0:'', meetingCap_1:'', meetingCap_2:'', meetingCap_3:'',
                                deepWorkBlocks_0:'', deepWorkBlocks_1:'', deepWorkBlocks_2:'', deepWorkBlocks_3:'',
                                exerciseBlocks_0:'', exerciseBlocks_1:'', exerciseBlocks_2:'', exerciseBlocks_3:'',
                                offRules_0:'', offRules_1:'', offRules_2:'', offRules_3:'',
                                deloadWeek_0:'', deloadWeek_1:'', deloadWeek_2:'', deloadWeek_3:'',
                                reducedTasks_0:'', reducedTasks_1:'', reducedTasks_2:'', reducedTasks_3:'',
                                reducedWindow_0:'', reducedWindow_1:'', reducedWindow_2:'', reducedWindow_3:'',
                                downshiftCues_0:'', downshiftCues_1:'', downshiftCues_2:'', downshiftCues_3:'',
                                loadAmplifiers_0:'', loadAmplifiers_1:'', loadAmplifiers_2:'', loadAmplifiers_3:'',
                                fullRestStart_0:'', fullRestStart_1:'', fullRestStart_2:'', fullRestStart_3:'',
                                fullRestEnd_0:'', fullRestEnd_1:'', fullRestEnd_2:'', fullRestEnd_3:'',
                                realRest_0:'', realRest_1:'', realRest_2:'', realRest_3:'',
                                stillAllowed_0:'', stillAllowed_1:'', stillAllowed_2:'', stillAllowed_3:'',
                                baselineMarkers_0:'', baselineMarkers_1:'', baselineMarkers_2:'', baselineMarkers_3:'',
                            })
                        }
                    }
                }
            } catch (error) {
                console.log(error);
                // Gérer les erreurs de récupération des données
            }
        };
        fetchInputValue();
    }, [user?.uid]);

    const updateFieldValue = async (_fieldName,newValue) => {
        try {
            if (user && !isAdminView) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);

                // Créer un objet avec le champ spécifié et sa nouvelle valeur
                const updatedData = {
                    ["Goals_cycle." + _fieldName]: newValue
                };

                // Mettre à jour l'état dynamiquement
                setGoalsData(prevState => ({
                    ...prevState,
                    [_fieldName]: newValue
                }));

                if (modalIsOpen) setModalIsOpen(false);
                await docRef.update(updatedData);
            } else if (isAdminView) {
                alert("Cannot save in admin view mode");
                if (modalIsOpen) setModalIsOpen(false);
            }
        } catch (error) {
            console.log(error);
            // Gérer les erreurs de mise à jour des données
        }
    };
    const updateInputValue = async (newValue) => {
        try {
            if (user && !isAdminView) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);

                // Créer un objet avec le champ spécifié et sa nouvelle valeur
                const updatedData = {
                    ["Goals_cycle." + fieldName]: newValue
                };

                // Mettre à jour l'état dynamiquement
                setGoalsData(prevState => ({
                    ...prevState,
                    [fieldName]: newValue
                }));

                if (modalIsOpen) setModalIsOpen(false);
                await docRef.update(updatedData);
            } else if (isAdminView) {
                alert("Cannot save in admin view mode");
                if (modalIsOpen) setModalIsOpen(false);
            }
        } catch (error) {
            console.log(error);
            // Gérer les erreurs de mise à jour des données
        }
    };

    const openModal = (fieldName, title) => {
        if (isAdminView) {
            alert("Cannot edit in admin view mode");
            return;
        }
        setDisplayContent(goalsData[fieldName]);
        setFieldName(fieldName);
        setModalTitle(title);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };
    return (
        <div className="tab-pane containerDashboardContent container-fluid" role="tabpanel" id="tab-1">
            <h5 className={"mt-3"}>
            </h5>
            <div className="container" style={{backgroundColor:"rgba(238,238,238,0.56)", padding: "1em", borderRadius: "1em"}}>
                <div className="row">
                    <div className="col"><h6>Start Date</h6>
                        <input className="bg-transparent border-0" style={{cursor:"pointer"}} type="date" value={goalsData[`startingPeriod_${currentWorkload}`]} onChange={(e) => updateFieldValue(`startingPeriod_${currentWorkload}`,e.target.value)}/>
                    </div>
                    <div className="col"><h6>End Date</h6>
                        <input className="bg-transparent border-0" style={{cursor:"pointer"}} type="date" value={goalsData[`endingPeriod_${currentWorkload}`]} onChange={(e) => updateFieldValue(`endingPeriod_${currentWorkload}`,e.target.value)}/>
                    </div>
                    <div className="col"><h6>Next Cycle Start</h6>
                        <input className="bg-transparent border-0" style={{cursor:"pointer"}} type="date" value={goalsData[`nextCycle_${currentWorkload}`]} onChange={(e) => updateFieldValue(`nextCycle_${currentWorkload}`,e.target.value)}/>
                    </div>
                    <div className="col" style={{cursor:"pointer"}} onClick={() => openModal(`deloading_${currentWorkload}`, "Planned Deload Weeks")}><h6>Planned Deload Weeks</h6> <div >{goalsData['deloading_' + currentWorkload]}</div></div>
                    <div className="col" style={{cursor:"pointer"}} onClick={() => openModal(`periodRecovery_${currentWorkload}`, "Full Rest Block")}><h6>Full Rest Block</h6> <div >{goalsData['periodRecovery_' + currentWorkload]}</div></div>
                </div>
            </div>
            <div className="container mt-4">
                <div className="row">
                    <div className="col col-xs-12 col-sm-12 col-md-3 col-lg-3">
                        <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                            <a className="nav-link active" id="v-pills-dream-tab" data-toggle="pill" href="#v-pills-dream" role="tab" aria-controls="v-pills-dream" aria-selected="true" onClick={() => setCurrentWorkload(0)}>NORMAL WORKLOAD</a>
                            <a className="nav-link" id="v-pills-end-tab" data-toggle="pill" href="#v-pills-end" role="tab" aria-controls="v-pills-end" aria-selected="false" onClick={() => setCurrentWorkload(1)}>OPTIMAL WORKLOAD</a>
                            <a className="nav-link" id="v-pills-performance-tab" data-toggle="pill" href="#v-pills-performance" role="tab" aria-controls="v-pills-performance" aria-selected="false" onClick={() => setCurrentWorkload(2)}>PEAK WORKLOAD</a>
                            <a className="nav-link" id="v-pills-process-tab" data-toggle="pill" href="#v-pills-process" role="tab" aria-controls="v-pills-process" aria-selected="false" onClick={() => setCurrentWorkload(3)}>HYPER WORKLOAD</a>
                        </div>
                    </div>
                    <div className="col col-xs-12 col-sm-12 col-md-9 col-lg-9">
                        <div className="tab-content" id="v-pills-tabContent">
                            <div className="tab-pane fade show active" id="v-pills-dream" role="tabpanel" aria-labelledby="v-pills-dream-tab">
                                <WorkloadTab currentWorkload={0} color="#80be14" percentage="Between 60 - 75% of Maximal Workload" openModal={openModal} goalsData={goalsData} />
                            </div>
                            <div className="tab-pane fade" id="v-pills-end" role="tabpanel" aria-labelledby="v-pills-end-tab">
                                <WorkloadTab currentWorkload={1} color="#ffe046" percentage="Between 75 - 85% of Maximal Workload" openModal={openModal} goalsData={goalsData} />
                            </div>
                            <div className="tab-pane fade" id="v-pills-performance" role="tabpanel" aria-labelledby="v-pills-performance-tab">
                                <WorkloadTab currentWorkload={2} color="#ec7723" percentage="Between 85 - 95% of Maximal Workload" openModal={openModal} goalsData={goalsData} />
                            </div>
                            <div className="tab-pane fade" id="v-pills-process" role="tabpanel" aria-labelledby="v-pills-process-tab">
                                <WorkloadTab currentWorkload={3} color="#b01500" percentage="95% & beyond of Maximal Workload" openModal={openModal} goalsData={goalsData} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {modalIsOpen && (
                <CustomModal
                    title={modalTitle}
                    closeModal={closeModal}
                    content={displayContent}
                    isOpen={modalIsOpen}
                    fieldName={fieldName}
                    saveField={updateInputValue}
                />
            )}
        </div>
    );
};

const WorkloadTab = ({ currentWorkload, color, percentage, openModal, goalsData }) => {
    return (
        <div>
            <h4 style={{color: color}}>{percentage}</h4>
            <SectionGroup 
                openModal={openModal} 
                title="1. Primary Outcome of This Cycle"
                fields={[
                    { title: "Primary outcome", fieldName: `globalView_cycles_${currentWorkload}` }
                ]}
                goalsData={goalsData}
            />
            <SectionGroup 
                openModal={openModal} 
                title="2. Priorities and non-negotiables"
                fields={[
                    { title: "Priority/core task", fieldName: `priority_${currentWorkload}` },
                    { title: "Non-negotiables", fieldName: `nonNegotiable_${currentWorkload}` }
                ]}
                goalsData={goalsData}
            />
            <SectionGroup 
                openModal={openModal} 
                title="3. Secondary Tasks"
                fields={[
                    { title: "Secondary tasks", fieldName: `secondary_cycles_${currentWorkload}` }
                ]}
                goalsData={goalsData}
            />
            <SectionGroup 
                openModal={openModal} 
                title="4. Tasks to Remove or Reduce During This Cycle"
                fields={[
                    { title: "Meetings to reduce", fieldName: `meetingsReduce_${currentWorkload}` },
                    { title: "Projects to pause", fieldName: `projectsPause_${currentWorkload}` },
                    { title: "Social, admin, or learning load to trim", fieldName: `socialLoad_${currentWorkload}` },
                    { title: "Contexts or responsibilities that should not expand", fieldName: `contextsNotExpand_${currentWorkload}` }
                ]}
                goalsData={goalsData}
            />
            <SectionGroup 
                openModal={openModal} 
                title="5. Weekly Structure and Protected Recovery"
                fields={[
                    { title: "Working days", fieldName: `workingDays_${currentWorkload}` },
                    { title: "Daily start landmark", fieldName: `dailyStart_${currentWorkload}` },
                    { title: "Daily end landmark", fieldName: `dailyEnd_${currentWorkload}` },
                    { title: "Target weekly hours", fieldName: `targetHours_${currentWorkload}` },
                    { title: "Meeting cap or admin cap", fieldName: `meetingCap_${currentWorkload}` },
                    { title: "Protected deep work blocks", fieldName: `deepWorkBlocks_${currentWorkload}` },
                    { title: "Protected exercise, family, or life-maintenance blocks", fieldName: `exerciseBlocks_${currentWorkload}` },
                    { title: "Evening, weekend, or full day off rules", fieldName: `offRules_${currentWorkload}` }
                ]}
                goalsData={goalsData}
            />
            <SectionGroup 
                openModal={openModal} 
                title="6. Deload Protocol"
                fields={[
                    { title: "Planned week number", fieldName: `deloadWeek_${currentWorkload}` },
                    { title: "Reduced task list", fieldName: `reducedTasks_${currentWorkload}` },
                    { title: "Reduced work window", fieldName: `reducedWindow_${currentWorkload}` }
                ]}
                goalsData={goalsData}
            />
            <SectionGroup 
                openModal={openModal} 
                title="7. Downshift Cues & Load amplifiers"
                fields={[
                    { title: "Downshift cues", fieldName: `downshiftCues_${currentWorkload}` },
                    { title: "Load Amplifiers", fieldName: `loadAmplifiers_${currentWorkload}` }
                ]}
                goalsData={goalsData}
            />
            <SectionGroup 
                openModal={openModal} 
                title="8. Full Rest & Re-entry Protocol"
                fields={[
                    { title: "Full rest start date", fieldName: `fullRestStart_${currentWorkload}` },
                    { title: "Full rest end date", fieldName: `fullRestEnd_${currentWorkload}` },
                    { title: "What counts as real rest", fieldName: `realRest_${currentWorkload}` },
                    { title: "What is still allowed if needed", fieldName: `stillAllowed_${currentWorkload}` },
                    { title: "Return-to-baseline markers", fieldName: `baselineMarkers_${currentWorkload}` }
                ]}
                goalsData={goalsData}
            />
            <SectionGroup 
                openModal={openModal} 
                title="9. Workload sustainability"
                fields={[
                    { title: "How Many Times Per Year Can You Repeat the Cycle?", fieldName: `repeat_cycle_${currentWorkload}` }
                ]}
                goalsData={goalsData}
            />
        </div>
    );
};

const SectionGroup = ({ openModal, title, fields, goalsData }) => {
    return (
        <div className="mb-4">
            <h6 className="fw-bold mb-3 text-uppercase" style={{ fontSize: "0.9rem" }}>{title}</h6>
            {fields.map((field, idx) => (
                <div key={idx} className="mb-2" style={{ paddingLeft: "0.5rem" }}>
                    <SubField openModal={openModal} title={field.title} fieldName={field.fieldName} goalsData={goalsData} />
                </div>
            ))}
        </div>
    );
};

const SubField = ({ openModal, title, fieldName, goalsData }) => {
    return (
        <div>
            <p style={{ cursor: "pointer", fontSize: "0.85rem", marginBottom: "0.25rem" }} onClick={() => openModal(fieldName, title)}>
                <span style={{ textDecoration: "underline" }}>{title}</span>
                <TiPencil style={{ marginLeft: "0.5em", fontSize: "0.9rem" }} />
            </p>
            <div onDoubleClick={() => openModal(fieldName, title)} className="contentText" style={{ fontSize: "0.85rem" }}>
                {goalsData[fieldName] || 'Not specified'}
            </div>
        </div>
    );
};

const Card = ({ openModal, title, fieldName, goalsData }) => {
    return (
        <div className="mb-4 fondGris">
            <p style={{ cursor: "pointer" }} onClick={() => openModal(fieldName, title)}>
                <span style={{ textDecoration: "underline" }}>{title}</span>
                <TiPencil style={{ marginLeft: "0.5em" }} />
            </p>
            <div onDoubleClick={() => openModal(fieldName, title)} className="contentText">
                {goalsData[fieldName]}
            </div>
        </div>
    );
};


export default Cycles_Content;
